const config = {
  baseUrl: 'https://stg-mobile.bangkokdrugstore.co.th',
  apmServiceName: 'medlink-stg',
  env: 'stg'
};

export default config;
